import React, { useMemo } from 'react'
import styles from '../index.scss'
import orderBy from 'lodash/orderBy'

interface RecordProps {
  name?: string
  code?: string
  phonePre?: string
}
interface opProps {
  inputValue?: string
  data: {
    name?: string
    code?: string
    phonePre?: string
  }[]
  onChange?: (record: RecordProps) => void
}

const SearchList = (props: opProps) => {
  const showDataSource = useMemo(() => {
    let data = props?.data || {}
    let _dataSource = data.filter((node: RecordProps) => (node?.name?.includes?.(props?.inputValue) || node?.phonePre?.includes?.(props?.inputValue)))
    const _data = orderBy(_dataSource, ['firstWord'], ['asc'])
    return _data || []
  }, [props?.inputValue, props?.data])

  return (
    <div className={styles['dp-location-select']}>
      {showDataSource?.map((item: RecordProps) => {
        return (
          <div
            className={styles['dp-location-select--item']}
            key={item.code}
            onClick={() => props?.onChange?.(item)}
          >
            <span className={styles['dp-location-select--item-city']}>
              {item.name}
            </span>
            {
              item?.phonePre && <span className={styles['dp-location-select--item-country']}>（{item.phonePre}）</span>
            }
          </div>
        )
      })}
    </div>
  )
}

export default SearchList
